import { render, staticRenderFns } from "./ResourceBundleInfo.vue?vue&type=template&id=e6d886b8&"
import script from "./ResourceBundleInfo.vue?vue&type=script&lang=js&"
export * from "./ResourceBundleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports